"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  number: "1",
  title: "諮詢預約",
  description: "撥打免費專線 0800-555-705 或透過 Line 預約，專業團隊將為您安排專屬的居家聽力顧問。",
  linkText: "",
  linkUrl: ""
}, {
  number: "2",
  title: "到府檢測",
  description: "驗配師攜帶精密醫療級檢測儀器到府，在您最熟悉的居家環境中進行精準的聽力評估與檢查。",
  linkText: "",
  linkUrl: ""
}, {
  number: "3",
  title: "精準適配",
  description: "根據檢測結果現場選配並調整設備，確保您能即刻感受清晰自然的音質，重拾聆聽的喜悅。",
  linkText: "服務實績",
  linkUrl: "https://interton.com.tw/category/%e5%af%a6%e7%b8%be%e6%a1%88%e4%be%8b%e5%88%86%e4%ba%ab/"
}];
export default function SimpleThreeStepsToStartExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="157382" id="六大專業服務流程" className="dark bg-secondary py-20 md:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
            專業服務流程
          </h2>
          <p className="text-lg text-white/80">
            瑞聲助聽器到府服務團隊，為您提供最貼心、最專業的居家聽力照護服務。
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-8 left-[16.66%] w-[66.66%] h-[2px] border-t-2 border-dashed border-white/20 z-0" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
            {steps.map((step, i) => <div key={i} data-index={i} className={`relative z-10 flex flex-col items-center text-center transition-all duration-700 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <div className="w-16 h-16 rounded-full bg-white text-[var(--chart-2)] flex items-center justify-center text-2xl font-bold shadow-xl mb-6 ring-8 ring-secondary/50">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-white mb-3">
                  {step.title}
                </h3>
                <p className="text-white/80 leading-relaxed mb-4 max-w-xs mx-auto">
                  {step.description}
                </p>
                {step.linkText && step.linkUrl && <Link to={step.linkUrl} className="inline-flex items-center bg-white text-primary px-5 py-2 rounded-sm hover:bg-white/90 font-bold transition-all shadow-md mt-auto">
                    {step.linkText}
                    <ArrowRight className="ml-1 w-4 h-4" />
                  </Link>}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}